function formatDollars(amount) {
  return `$${amount.toLocaleString('en-US')}`
}

export default formatDollars
